import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconServer1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconServer1"><Path d="M19.5 5.13889C19.5 6.59631 16.1421 7.77778 12 7.77778C7.85786 7.77778 4.5 6.59631 4.5 5.13889M19.5 5.13889C19.5 3.68147 16.1421 2.5 12 2.5C7.85786 2.5 4.5 3.68147 4.5 5.13889M19.5 5.13889V18.8611C19.5 20.3185 16.1421 21.5 12 21.5C7.85786 21.5 4.5 20.3185 4.5 18.8611V5.13889M19.5 11.8887C19.5 13.3461 16.1421 14.5276 12 14.5276C7.85786 14.5276 4.5 13.3461 4.5 11.8887" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconServer1;
